import React, { useEffect, useMemo, useState } from 'react';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { getPerformanceList } from '@/pages/dashboard/services/benchmark';

export default function GTDRCommonService(props: any) {
  const { style, className, api, commonApi, dataKey = 'commonData', filterValue, filterLoading, gameCode, studioCode, children, extraParams = {}, ...resetProps } = props || {};
  // 基准数据
  const [performanceData, setPerformanceData] = useState([]);
  const [performanceLoading, setPerformanceLoading] = useState(false);
  const [performanceError, setPerformanceError] = useState(false);

  const data = useMemo(() => ({
    gameCode,
    studioCode,
    // 多层数据挂载
    ...(extraParams || {})
  }), [gameCode, studioCode, extraParams]);

  // 指标最大值接口，指标改变才重新请求

  useEffect(() => {
    setPerformanceLoading(true);
    getPerformanceList({
      "game_code": gameCode,
      "studio_code": studioCode,
    }, commonApi).then((res) => {
      setPerformanceData(res);
      setPerformanceError(false);
    }).catch(err => {
      console.log("★ ~ err>>", err);
      setPerformanceError(true);
    }).finally(() => {
      setPerformanceLoading(false);
    });
  }, [commonApi, gameCode, studioCode]);

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        dataKey={dataKey}
        filterVal={filterValue}
        filterLoading={filterLoading}
        trackData={["gameCode","studioCode"]}
        beforeRequest={(data) => {
          const { filterVal, gameCode, studioCode } = data;
          const params = {
            "game_code": gameCode,
            "version_list": filterVal?.version,
            "studio_code": studioCode,
            ...extraParams,
          };
          return params;
        }}
      >
        {React.Children.map(children, (child: any) => React.cloneElement(
          child,
          {
            ...resetProps,
            gameCode,
            studioCode,
            performanceData,
            performanceLoading,
            performanceError,
            filterValue,
            filterLoading
          }
        ))}
      </Service>
    </div>
  );
};
